export { default as StoreLocator } from './StoreLocator';
